import { ReactElement } from 'react';

import { useFormController } from '@dreryk/react-common';

import { ProAuctoreAndProFamiliaMissingDoctorContactDetails } from '../ProAuctoreAndProFamiliaMissingContactDetailsModal.types';

import { isAddressMissing, isPhoneNumberMissing } from './ProAuctoreAndProFamiliaMissingContactDetailsForm.utils';
import {
   ProAuctoreAndProFamiliaMissingDetailsFormBean,
   ProAuctoreAndProFamiliaMissingDetailsFormController,
} from './ProAuctoreAndProFamiliaMissingDetailsForm.types';
import { AddressSection } from './sections/AddressSection/AddressSection';
import { PhoneNumberSection } from './sections/PhoneNumberSection/PhoneNumberSection';
import { StyledProAuctoreAndProFamiliaMissingContactDetailsForm } from './ProAuctoreAndProFamiliaMissingContactDetailsForm.styled';

const INITIAL_VALUES: ProAuctoreAndProFamiliaMissingDetailsFormBean = {
   postcode: null,
   phoneNumber: null,
   town: null,
   street: null,
   building: null,
   flat: null,
};

type ProAuctoreAndProFamiliaMissingDetailsFormChildrenRenderProps = Pick<
   ProAuctoreAndProFamiliaMissingDetailsFormController,
   'handleSubmit' | 'formState'
>;

type ProAuctoreAndProFamiliaMissingDetailsFormProps = {
   readonly children: (props: ProAuctoreAndProFamiliaMissingDetailsFormChildrenRenderProps) => ReactElement;
   readonly missingDetails: ProAuctoreAndProFamiliaMissingDoctorContactDetails;
};

export const ProAuctoreAndProFamiliaMissingContactDetailsForm = (
   props: ProAuctoreAndProFamiliaMissingDetailsFormProps
): ReactElement => {
   const { handleSubmit, register, formState } = useFormController<ProAuctoreAndProFamiliaMissingDetailsFormBean>(
      INITIAL_VALUES
   );
   return (
      <StyledProAuctoreAndProFamiliaMissingContactDetailsForm as={'form'} direction={'column'} gap={'18px'} noValidate>
         {isPhoneNumberMissing(props.missingDetails) ? <PhoneNumberSection register={register} /> : null}
         {isAddressMissing(props.missingDetails) ? <AddressSection register={register} /> : null}

         {props.children({ handleSubmit: handleSubmit, formState: formState })}
      </StyledProAuctoreAndProFamiliaMissingContactDetailsForm>
   );
};
